// extracted by mini-css-extract-plugin
export default {"container":"ImageSpecsBadges_container__8vmbJ","specsContainer":"ImageSpecsBadges_specsContainer__seIdE","specBadge":"ImageSpecsBadges_specBadge__R6FaA"};